import { Injectable } from '@angular/core';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';

@Injectable()
export class FcButtonPositionService {

  // Créé un Observable populé par le json sessions.json
  private fcButtonPos = new BehaviorSubject<any>(false);
  public fcButtonPos$ = this.fcButtonPos.asObservable();

  constructor() {}

  public setListSessions(fcButtonPos: any) {
    this.fcButtonPos.next(fcButtonPos);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/fc-button-position.service.ts